import React from "react";
import HTML from "../img/icons/HTML.svg";
import CSS from "../img/icons/CSS.svg";
import JS from "../img/icons/JS.svg";
import REACT from "../img/icons/REACT.svg";
import GITHUB from "../img/icons/GITHUB.svg";
import NPM from "../img/icons/NPM.svg";
import NODE from "../img/icons/NODE.svg";
import MONGODB from "../img/icons/MONGODB.svg";
import MYSQL from "../img/icons/MYSQL.svg";
import { motion } from "framer-motion";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";
import { simpleContainer3, hideAnimation2 } from "../animate";

const CoursesContentIcon = () => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="iconPart" style={{ marginTop: "20vh" }}>
      <h2>
        <span>課程涵蓋內容</span>
      </h2>
      <motion.div
        className="icons"
        initial="hidden"
        variants={simpleContainer3}
        animate={controls}
        ref={element}
      >
        <div className="icon">
          <motion.img variants={hideAnimation2} src={HTML} alt="" />
          <h5>HTML</h5>
        </div>
        <div className="icon">
          <motion.img variants={hideAnimation2} src={CSS} alt="" />
          <h5>CSS</h5>
        </div>
        <div className="icon">
          <motion.img variants={hideAnimation2} src={JS} alt="" />
          <h5>JavaScript</h5>
        </div>
        <div className="icon">
          <motion.img variants={hideAnimation2} src={REACT} alt="" />
          <h5>React</h5>
        </div>
        <div className="icon">
          <motion.img variants={hideAnimation2} src={GITHUB} alt="" />
          <h5>GitHub</h5>
        </div>
        <div className="icon">
          <motion.img variants={hideAnimation2} src={NPM} alt="" />
          <h5>npm</h5>
        </div>
        <div className="icon">
          <motion.img variants={hideAnimation2} src={NODE} alt="" />
          <h5>Node.js</h5>
        </div>
        <div className="icon">
          <motion.img variants={hideAnimation2} src={MONGODB} alt="" />
          <h5>MongoDB</h5>
        </div>
        <div className="icon">
          <motion.img variants={hideAnimation2} src={MYSQL} alt="" />
          <h5>MySQL</h5>
        </div>
      </motion.div>
    </div>
  );
};

export default CoursesContentIcon;
